// Import collection images
import Collection1 from '@/assets/images/section-collection/collection-1.jpg';
import Collection2 from '@/assets/images/section-collection/collection-2.jpg';
import Collection3 from '@/assets/images/section-collection/collection-3.jpg';
import Collection4 from '@/assets/images/section-collection/collection-4.jpg';
import Collection5 from '@/assets/images/section-collection/collection-5.jpg';
import Collection6 from '@/assets/images/section-collection/collection-6.jpg';
import Collection7 from '@/assets/images/section-collection/collection-7.jpg';
import Collection8 from '@/assets/images/section-collection/collection-8.jpg';
import Collection9 from '@/assets/images/section-collection/collection-9.jpg';

export const SECTION_COLLECTION_DATA = [
    {
        id: '1',
        name: 'Collection 1',
        description: 'Description 1',
        image: Collection1,
    },
    {
        id: '2',
        name: 'Collection 2',
        description: 'Description 2',
        image: Collection2,
    },
    {
        id: '3',
        name: 'Collection 3',
        description: 'Description 3',
        image: Collection3,
    },
    {
        id: '4',
        name: 'Collection 4',
        description: 'Description 4',
        image: Collection4,
    },
    {
        id: '5',
        name: 'Collection 5',
        description: 'Description 5',
        image: Collection5,
    },
    {
        id: '6',
        name: 'Collection 6',
        description: 'Description 6',
        image: Collection6,
    },
    {
        id: '7',
        name: 'Collection 7',
        description: 'Description 7',
        image: Collection7,
    },
    {
        id: '8',
        name: 'Collection 8',
        description: 'Description 8',
        image: Collection8,
    },
    {
        id: '9',
        name: 'Collection 9',
        description: 'Description 9',
        image: Collection9,
    },
    {
        id: '10',
        name: 'Collection 4',
        description: 'Description 4',
        image: Collection4,
    },
    {
        id: '11',
        name: 'Collection 5',
        description: 'Description 5',
        image: Collection5,
    },
    {
        id: '12',
        name: 'Collection 6',
        description: 'Description 6',
        image: Collection5,
    },
]